var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('staging-control'),_c('staging-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }